export default "__VITE_ASSET__bc96251e__"